import { render, staticRenderFns } from "./speechAdd.vue?vue&type=template&id=a03aeedc"
import script from "./speechAdd.vue?vue&type=script&lang=js"
export * from "./speechAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports